import * as moment from 'moment';
import { map } from 'rxjs/operators';
import { BehaviorSubject, merge, combineLatest } from 'rxjs';
import { orderBy, cloneDeep } from 'lodash';

class DateHelper {
    static formatDate(val) {
        if (val == null) {
            return null;
        }
        try {
            let dtm = moment(val);
            let str2 = dtm.format("YYYY-MM-DD");
            //str2+= "T00:00:00Z";
            return str2;
        }
        catch (e) {
            console.log(e);
            return null;
        }
    }
    static formatDateTime(val) {
        if (val == null) {
            return null;
        }
        try {
            let dtm = moment(val);
            let str2 = dtm.format("YYYY-MM-DD HH:MM:SS");
            //str2+= "T00:00:00Z";
            return str2;
        }
        catch (e) {
            console.log(e);
            return null;
        }
    }
    static sortByDate(a, b) {
        let a1 = new Date(a);
        let b1 = new Date(b);
        if (a1 < b1) {
            return -1;
        }
        else if (a1 > b1) {
            return 1;
        }
        else {
            return 0;
        }
    }
}

class SortHelper {
    //USAR sortMultiple, es mas lento pero da mejores resultados
    /**
     * Sort by multiple fields
     * Example: SortHelper.sortMultiple(ARRAY, ['info.date','info.panel.locator.L1', 'info.panel.locator.L2', 'info.panel.locator.L3', 'info.panel.locator.L4']);
      }
     * @param array
     * @param fields
     * @param sort
     */
    static sortMultiple(array, fields, sort) {
        if (sort) {
            return orderBy(array, fields, sort);
        }
        else {
            return orderBy(array, fields);
        }
    }
    /**
     * use only when sort field used is tabular
     * @param dataOrigin
     * @param sort
     */
    sortDataBySort(dataOrigin, sort) {
        const data = dataOrigin.slice();
        let sortedData;
        if (!sort.active || sort.direction === '') {
            sortedData = data;
            return;
        }
        let fieldToSort = sort.active;
        let isAsc = sort.direction === 'asc';
        sortedData = SortHelper.sortMultiple(data, [fieldToSort], [isAsc]);
        return sortedData;
    }
    //ejemplo, no se usa en ningun lugar
    static sortData(datasource, sort) {
        const data = datasource.slice();
        if (!sort.active || sort.direction === '') {
            return data;
        }
        let sortedData = data.sort((a, b) => {
            const isAsc = sort.direction === SortHelper.Asc;
            switch (sort.active) {
                case 'name': return SortHelper.sortby(a.name, b.name, isAsc);
                case 'calories': return SortHelper.sortby(a.calories, b.calories, isAsc);
                default: return 0;
            }
        });
    }
    static sortby(a, b, isAsc) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }
    static sortbyDate(a, b, isAsc) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }
    /**
     * Example:  let Sorted= arraySource.sort((a, b) => SortHelper.sortByString(a.name, b.name));
     * @param field1
     * @param field2
     */
    static sortByString(field1, field2, isAsc) {
        return SortHelper.sortByStringLocale(field1, field2, isAsc);
    }
    static sortByStringLocale(a, b, isAsc = true) {
        let aN = SortHelper.normalizeValue(a);
        let bN = SortHelper.normalizeValue(b);
        let res = new Intl.Collator().compare(aN, bN) * (isAsc ? 1 : -1);
        return res;
    }
    /**
   * usamos sortMultiple con lodash dado que la aplicacion usa mucho el campo info
   * @param property
   */
    static dynamicSort(property) {
        let sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            /* next line works with strings and numbers,
             * and you may want to customize it to your needs
             */
            let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            return result * sortOrder;
        };
    }
    /**
     * NO USAR
     */
    static dynamicSortMultiple(...props) {
        /*
         * save the arguments object as it will be overwritten
         * note that arguments object is an array-like object
         * consisting of the names of the properties to sort by
         */
        //let props = arguments;
        return function (obj1, obj2) {
            let i = 0, result = 0, numberOfProperties = props.length;
            /* try getting a different result from 0 (equal)
             * as long as we have extra properties to compare
             */
            while (result === 0 && i < numberOfProperties) {
                result = SortHelper.dynamicSort(props[i])(obj1, obj2);
                i++;
            }
            return result;
        };
    }
    static normalizeValue(value) {
        let str = value.toLowerCase().replace(/\s/g, '');
        str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return str;
    }
}
SortHelper.Asc = 'asc';
SortHelper.Desc = 'desc';

/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, ExampleDatabase. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */
class DataSourceHelper {
    constructor(baseService) {
        this.baseService = baseService;
        this._filterChange = new BehaviorSubject(0);
        this.filteredData = [];
        this.renderedData = [];
        //super();
    }
    get filter() { return this._filterChange.value; }
    set filter(filter) { this._filterChange.next(filter); }
    /**
 * Instance of the MatPaginator component used by the table to control what page of the data is
 * displayed. Page changes emitted by the MatPaginator will trigger an update to the
 * table's rendered data.
 *
 * Note that the data source uses the paginator's properties to calculate which page of data
 * should be displayed. If the paginator receives its properties as template inputs,
 * e.g. `[pageLength]=100` or `[pageIndex]=1`, then be sure that the paginator's view has been
 * initialized before assigning it to this data source.
 */
    get paginator() { return this._paginator; }
    set paginator(paginator) {
        this._paginator = paginator;
    }
    get sort() { return this._sort; }
    set sort(sort) {
        this._sort = sort;
    }
    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect() {
        // Listen for any changes in the base data, sorting, filtering, or pagination
        const displayDataChanges = [
            this.baseService,
            this._paginator.page,
            this._sort.sortChange,
            this._filterChange
        ];
        return merge(...displayDataChanges).pipe(map(() => {
            if (!this.baseService) {
                return;
            }
            // Filter data
            let v = this.filter;
            if (!v) {
                this.filteredData = this.baseService.slice();
            }
            else {
                this.filteredData = this.baseService.slice().filter(elem => elem.info.status == v);
            }
            // Sort filtered data
            const sortedData = this.sortData(this.filteredData.slice(), this._sort); //this.sortData(this.filteredData.slice());
            // Grab the page's slice of the filtered sorted data.
            const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            const pageSize = this._paginator.pageSize;
            this.renderedData = sortedData.splice(startIndex, pageSize);
            /* console.log("filteredData= "+ this.filteredData.length);
            console.log("this._paginator.pageIndex= "+this._paginator.pageIndex); */
            return this.renderedData;
        }));
    }
    sortData(data, sort) {
        let sortedData = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'name': return SortHelper.sortByString(a.name, b.name, isAsc);
                case 'type': return SortHelper.sortByString(a.type, b.type, isAsc);
                default: return 0;
            }
        });
        return sortedData;
    }
    disconnect() { }
}

class ObjHelper {
    //USAR sortMultiple, es mas lento pero da mejores resultados
    /**
     * Sort by multiple fields
     * Example: SortHelper.sortMultiple(ARRAY, ['info.date','info.panel.locator.L1', 'info.panel.locator.L2', 'info.panel.locator.L3', 'info.panel.locator.L4']);
      }
     * @param array
     * @param fields
     * @param sort
     */
    static cloneDeep(obj) {
        return cloneDeep(obj); //second parameter 
    }
}

class TableList {
    constructor(initialData = []) {
        /** Stream that emits when a new filter string is set on the data source. */
        this._filter = new BehaviorSubject('');
        /**
       * Checks if a data object matches the data source's filter string. By default, each data object
       * is converted to a string of its properties and returns true if the filter has
       * at least one occurrence in that string. By default, the filter string has its whitespace
       * trimmed and the match is case-insensitive. May be overridden for a custom implementation of
       * filter matching.
       * @param data Data object used to check against the filter.
       * @param filter Filter string that has been set on the data source.
       * @returns Whether the filter matches against the data
       */
        this.filterPredicate = (data, filter) => {
            // Transform the data into a lowercase string of all property values.
            const dataStr = Object.keys(data).reduce((currentTerm, key) => {
                // Use an obscure Unicode character to delimit the words in the concatenated string.
                // This avoids matches where the values of two columns combined will match the user's query
                // (e.g. `Flute` and `Stop` will match `Test`). The character is intended to be something
                // that has a very low chance of being typed in by somebody in a text field. This one in
                // particular is "White up-pointing triangle with dot" from
                // https://en.wikipedia.org/wiki/List_of_Unicode_characters
                return currentTerm + data[key] + '◬';
            }, '').toLowerCase();
            // Transform the filter by converting it to lowercase and removing whitespace.
            const transformedFilter = filter.trim().toLowerCase();
            return dataStr.indexOf(transformedFilter) != -1;
        };
        this._data = new BehaviorSubject(initialData);
        //this._updateChangeSubscription();
        this._filterData(this.data);
    }
    /** Array of data that should be rendered by the table, where each object represents one row. */
    get data() { return this._data.value; }
    set data(data) {
        this._data.next(data);
        this._filterData(this.data);
    }
    /**
   * Filter term that should be used to filter out objects from the data array. To override how
   * data objects match to this filter string, provide a custom function for filterPredicate.
   */
    get filter() { return this._filter.value; }
    set filter(filter) { this._filter.next(filter); }
    add(item) {
        this._data.value.push(item);
        if (this.filter && this.filter !== "") {
            this._filterData(this.data);
        }
        else {
            this.filteredList.push(item);
        }
    }
    update(index, item) {
        this.data[index] = item;
    }
    removebyindex(index) {
        //const index = this.listOriginal.findIndex(el => el.id == id, 0);
        let item = this.data[index];
        if (index > -1) {
            this.data.splice(index, 1);
            //find in filtered list or filter again
            this._filterData(this.data);
        }
    }
    /**
  * Returns a filtered data array where each filter object contains the filter string within
  * the result of the filterTermAccessor function. If no filter is set, returns the data array
  * as provided.
  */
    _filterData(data) {
        // If there is a filter string, filter out data that does not contain it.
        // Each data object is converted to a string using the function defined by filterTermAccessor.
        // May be overridden for customization.
        this.filteredData =
            !this.filter ? data : data.filter(obj => this.filterPredicate(obj, this.filter));
        return this.filteredData;
    }
    filterData1() {
        const dataStream = this._data;
        // Watch for base data or filter changes to provide a filtered set of data.
        const filteredData = combineLatest([dataStream, this._filter])
            .pipe(map(([data]) => this._filterData(data)));
        return filteredData;
    }
    filterData(filterString) {
        this.filter = filterString;
        this.filteredData =
            !this.filter ? this.data : this.data.filter(obj => this.filterPredicate(obj, this.filter));
        return this.filteredData;
    }
}

class TimePerf {
    static timeElapsed(startTime, message = "") {
        let endTime = new Date();
        let endTimeMs = endTime.valueOf(); //endTime.getMilliseconds();
        let startTimeMs = startTime.valueOf();
        let timeDiff = endTimeMs - startTimeMs; //in ms
        // strip the ms
        timeDiff /= 1000;
        // get seconds 
        //var seconds = Math.round(timeDiff);
        if (message) {
            console.log(message + " " + timeDiff + " s");
        }
        return timeDiff;
    }
}

/**
 * Clase para validar numeros basicamente al
 */
class ValidatorHelper {
    static keyIsCopyPaste(e) {
        //control + copy/paste
        if (e.ctrlKey == true && (e.keyCode == 67 || e.keyCode == 86)) {
            return true;
        }
        return false;
    }
    static keyIsPercent(e) {
        if (e.shiftKey == true && (e.keyCode == 53)) {
            // percent
            return true;
        }
        return false;
    }
    static keyIsSeparator(e) {
        //188= , (comma) //190= .(punto)//110=.(punto teclado numerico)
        if (e.keyCode == 190 || e.keyCode == 110 || e.keyCode == 108) {
            return true;
        }
        return false;
    }
    static keyIsMinusSymbol(e) {
        //109 y 189 =-(minus symbol)
        if (e.keyCode == 109 || e.keyCode == 189) {
            return true;
        }
        return false;
    }
    static onInputValidatorNumBase(e, options) {
        //48 a 57 es 0 a 9
        if ((e.keyCode > 47 && e.keyCode < 58)) {
            return true;
        }
        if (e.keyCode >= 37 && e.keyCode <= 40) {
            return true;
        }
        //95 a 106 son 0 a 9 en el teclado superior
        if (e.keyCode > 95 && e.keyCode < 106) {
            return true;
        }
        //8 backspace 46=supr 9=tab
        if (e.keyCode == 8 || e.keyCode == 9 || e.keyCode == 46) {
            return true;
        }
        return false;
    }
    /**
     * Generica de numeros
     * @param e
     * @param options
     */
    static onInputValidator(e, options) {
        //this.values = (<HTMLInputElement>e.target).value ;
        //console.log("event:", e.keyCode);
        //48 a 58 es 0 a 9
        //95 a 106 son 0 a 9 en el teclado superior
        //8 backspace 46=supr 9=tab
        //188= , (comma) //190= .(punto)//110=.(punto teclado numerico)
        // 53=%  109=-(minus symbol)
        if (e.keyCode == 8 || e.keyCode == 9 || e.keyCode == 190 || e.keyCode == 110 || e.keyCode == 46 || e.keyCode == 109 || e.keyCode == 189) {
            //console.log("Valid key:", e.keyCode);
            return;
        }
        if (e.ctrlKey == true && (e.keyCode == 67 || e.keyCode == 86)) {
            //copy/paste
            return;
        }
        if (!((e.keyCode > 95 && e.keyCode < 106) || (e.keyCode > 47 && e.keyCode < 58)
            || (e.keyCode >= 37 && e.keyCode <= 40))) {
            //console.log("Valid key:", e.keyCode);
            return false;
        }
    }
    /**
     * Solo admite numeros
     * @param e
     * @param options
     */
    static onInputValidatorOnlyNum(e, options) {
        //this.values = (<HTMLInputElement>e.target).value ;
        console.log("event:", e.keyCode, e.ctrlKey);
        //prohibited
        if (options != null) {
            if (options == "1") {
                if (this.keyIsMinusSymbol(e)) {
                    return false; //negative symbol is not acepted
                }
            }
        }
        //no percent is valid
        if (this.keyIsPercent(e)) {
            return false;
        }
        //allowed 
        if (this.keyIsCopyPaste(e)) {
            return true;
        }
        if (this.keyIsSeparator(e)) {
            return true; //allow separator
        }
        if (this.onInputValidatorNumBase(e, options)) {
            return true;
        }
        return false;
    }
    static onInputValidatorOnlyNumFixed(e, options) {
        console.log("key:", e.keyCode);
        //prohibited
        if (this.keyIsSeparator(e)) {
            return false; //not allow separator
        }
        //no percent is valid
        if (this.keyIsPercent(e)) {
            return false;
        }
        //control + copy/paste
        if (this.keyIsCopyPaste(e)) {
            return true;
        }
        if (options != null) {
            if (options == "1") {
                if (this.keyIsMinusSymbol(e)) {
                    return false; //negative symbol is not acepted
                }
            }
        }
        if (this.keyIsMinusSymbol(e)) {
            return true; //negative symbol IS acepted
        }
        if (this.onInputValidatorNumBase(e, options)) {
            return true;
        }
        return false;
    }
    /**
     * Generica de numeros usando punto como separador decimal
     * @param e
     * @param options
     */
    static onInputValidatorNum(e, options) {
        //console.log("keyCode:", e.keyCode + " ctrlKey:" + e.ctrlKey + " shiftKey:" +e.shiftKey );
        //no percent is valid
        if (this.keyIsPercent(e)) {
            return false;
        }
        if (this.keyIsSeparator(e)) {
            return true; //allow separator
        }
        if (this.keyIsMinusSymbol(e)) {
            return true; //negative symbol IS acepted
        }
        if (this.onInputValidatorNumBase(e, options)) {
            return true;
        }
        return false;
    }
    /**
     * Generica de numeros usando punto como separador decimal y admitiendo valor porcentual
     * @param e
     * @param options
     */
    static onInputValidatorWithPercent(e, options) {
        //this.values = (<HTMLInputElement>e.target).value ;
        if (this.keyIsPercent(e)) {
            return true;
        }
        if (this.keyIsSeparator(e)) {
            return true; //allow separator
        }
        if (this.keyIsMinusSymbol(e)) {
            return true; //negative symbol IS acepted
        }
        if (this.onInputValidatorNumBase(e, options)) {
            return true;
        }
        return false;
    }
    static isNumber(value) {
        //https://stackoverflow.com/questions/23437476/in-typescript-how-to-check-if-a-string-is-numeric
        return !isNaN(Number(value.toString()));
    }
    static parseStringToNumber(str) {
        return parseFloat(str.replace(',', '.').replace(' ', ''));
    }
}

/*
 * Public API Surface of shtools
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DataSourceHelper, DateHelper, ObjHelper, SortHelper, TableList, TimePerf, ValidatorHelper };
//# sourceMappingURL=shtools.js.map
